module.exports = "<div class=\"col-sm-12 col-md-12 \">\n\n  <!-- <div class=\"row\">\n    <div class=\"col-md-12 col-sm-12 hidden-xs\">\n      <h1 class=\"fz-50 fw-300\">Dashboards</h1>\n    </div>\n    <div class=\"col-xs-12 visible-xs\">\n      <h1 class=\"fz-34 fw-300 ta-c\">Dashboard</h1>\n    </div>\n  </div> -->\n\n  <quick-search></quick-search>\n\n  <!-- <stats-dashboard></stats-dashboard> -->\n\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/main-dashboard/dashboard.component.html
// module id = ./src/app/dashboard/main-dashboard/dashboard.component.html
// module chunks = main